import { handleError } from "../common/ErrorUtil";

import { executeGraphqlLoop } from "./BaseApi";
import {
  listLoadDataEachProductDailies,
  listLoadDataEachProductLastMonths,
  listLoadDataEachShotDailies,
  listLoadDataEachShotLastMonths,
} from "./graphql/queries";

/**
 * 荷重  - 製品単位データ(日単位)一覧取得APIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeListLoadDataEachProductDailies(office, date) {
  const params = {
    office,
    dateProductId: { beginsWith: { date } },
    nextToken: null,
  };

  const key = "listLoadDataEachProductDailies";
  const { data, error } = await executeGraphqlLoop(
    listLoadDataEachProductDailies,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      productDailies: data[key].items,
    };
  } else {
    response.data = {
      productDailies: [],
    };
  }

  return response;
}

/**
 * 荷重  - 製品単位データ(月単位)一覧取得APIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeListLoadDataEachProductLastMonths(office, date) {
  const params = {
    office,
    dateProductId: { beginsWith: { date } },
    nextToken: null,
  };

  const key = "listLoadDataEachProductLastMonths";
  const { data, error } = await executeGraphqlLoop(
    listLoadDataEachProductLastMonths,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      productLastMonths: data[key].items,
    };
  } else {
    response.data = {
      productLastMonths: [],
    };
  }

  return response;
}

/**
 * 荷重  - Shot数単位データ(日単位)一覧取得APIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeListLoadDataEachShotDailies(office, date) {
  const params = {
    office,
    dateType: { beginsWith: { date } },
    nextToken: null,
  };

  const key = "listLoadDataEachShotDailies";
  const { data, error } = await executeGraphqlLoop(
    listLoadDataEachShotDailies,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      shotDailies: data[key].items,
    };
  } else {
    response.data = {
      shotDailies: [],
    };
  }

  return response;
}

/**
 * 荷重  - Shot数単位データ(月単位)一覧取得APIの実行.
 *
 * @return {object} レスポンス
 */
export async function executeListLoadDataEachShotLastMonths(office, date) {
  const params = {
    office,
    dateType: { beginsWith: { date } },
    nextToken: null,
  };

  const key = "listLoadDataEachShotLastMonths";
  const { data, error } = await executeGraphqlLoop(
    listLoadDataEachShotLastMonths,
    params,
    key
  ).catch(handleError);

  const response = { error };
  if (data && data[key] && data[key].items) {
    response.data = {
      shotLastMonths: data[key].items,
    };
  } else {
    response.data = {
      shotLastMonths: [],
    };
  }

  return response;
}
